import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden" }
const _hoisted_3 = { class: "bg-theme-green px-4 py-2 text-white" }
const _hoisted_4 = { class: "flex justify-between items-center" }
const _hoisted_5 = { class: "font-semibold truncate text-single-line break-all leading-tight text-2xl mt-0" }
const _hoisted_6 = { class: "flex items-end" }
const _hoisted_7 = { class: "pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-lg" }
const _hoisted_8 = { class: "flex gap-3 xl:flex-row flex-col items-start mb-3" }
const _hoisted_9 = { class: "w-full xl:w-4/5" }
const _hoisted_10 = ["textContent"]
const _hoisted_11 = { class: "w-full xl:w-1/5" }
const _hoisted_12 = { class: "input-wrapper" }
const _hoisted_13 = { class: "flex items-center cursor-pointer mt-1" }
const _hoisted_14 = { class: "flex gap-3 xl:flex-row flex-col items-start mb-3" }
const _hoisted_15 = { class: "w-full" }
const _hoisted_16 = ["textContent"]
const _hoisted_17 = { class: "flex gap-2 xl:flex-row flex-col pb-2" }
const _hoisted_18 = { class: "xl:w-1/2 w-full" }
const _hoisted_19 = { class: "block rounded bg-gray-black w-full flex items-center" }
const _hoisted_20 = ["textContent"]
const _hoisted_21 = { class: "xl:w-1/2 w-full" }
const _hoisted_22 = { class: "block rounded bg-gray-black w-full flex items-center" }
const _hoisted_23 = ["textContent"]
const _hoisted_24 = {
  key: 0,
  class: "text-xs font-semibold text-center text-theme-878686 text-theme-red"
}
const _hoisted_25 = {
  key: 1,
  class: /*@__PURE__*/_normalizeClass('holiday-activity overflow-y-auto h-[300px]')
}
const _hoisted_26 = { class: "flex flex-row justify-between gap-3 mb-2" }
const _hoisted_27 = { class: "w-full xl:w-1/3 h-[65px] flex items-center" }
const _hoisted_28 = { class: "input-wrapper flex justify-between" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "mr-2 text-base text-theme-878686 font-semibold" }
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = { class: "w-full xl:w-1/3" }
const _hoisted_33 = {
  class: /*@__PURE__*/_normalizeClass('input-wrapper')
}
const _hoisted_34 = { class: "block rounded bg-gray-black w-full relative" }
const _hoisted_35 = { class: "bg-gray-black rounded flex items-center w-full pr-[80px] rounded px-1 py-2" }
const _hoisted_36 = ["onChange", "onUpdate:modelValue"]
const _hoisted_37 = ["value"]
const _hoisted_38 = ["onUpdate:modelValue", "onChange"]
const _hoisted_39 = ["value"]
const _hoisted_40 = { class: "flex items-center cursor-pointer absolute right-1 top-2" }
const _hoisted_41 = ["onChange", "onUpdate:modelValue"]
const _hoisted_42 = { class: "w-full xl:w-1/3" }
const _hoisted_43 = {
  class: /*@__PURE__*/_normalizeClass('input-wrapper')
}
const _hoisted_44 = { class: "block rounded bg-gray-black w-full relative" }
const _hoisted_45 = { class: "bg-gray-black rounded flex items-center w-full pr-[80px] rounded py-2" }
const _hoisted_46 = ["onUpdate:modelValue", "onChange"]
const _hoisted_47 = ["value"]
const _hoisted_48 = ["onUpdate:modelValue", "onChange"]
const _hoisted_49 = ["value"]
const _hoisted_50 = { class: "flex items-center cursor-pointer absolute right-2 top-2" }
const _hoisted_51 = ["onChange", "onUpdate:modelValue"]
const _hoisted_52 = {
  key: 0,
  class: "text-theme-red w-full text-end text-xs"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_ReturnConfirmModal = _resolveComponent("ReturnConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.form.name.value), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.update()), ["prevent"])),
                class: "tracking-widest cursor-pointer bg-white py-2 px-4 rounded text-theme-green hover:bg-theme-darkgreen hover:text-white mr-3"
              }, " SAVE "),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.deleteRecord()), ["prevent"])),
                class: "cursor-pointer rounded-md bg-white text-theme-red py-2 px-4 hover:bg-theme-darkgreen hover:text-white mr-3"
              }, "DELETE"),
              _createElementVNode("span", {
                onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearComponent && _ctx.clearComponent(...args)), ["prevent"])),
                class: "cursor-pointer rounded-md text-white py-2 pl-1 hover:opacity-70"
              }, "CLOSE")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: _normalizeClass('input-wrapper ' + (_ctx.form.name.error_type))
              }, [
                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "text-xs mb-1" }, "Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.name.value) = $event)),
                  onKeyup: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validateFields(['name']))),
                  placeholder: "May the Fourth",
                  class: "block border-none rounded bg-gray-black w-full text-sm text-theme-white placeholder-gray-100::placeholder",
                  type: "text"
                }, null, 544), [
                  [_vModelText, _ctx.form.name.value]
                ]),
                (_ctx.form.name.error_message)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: "field-error label-text mt-1",
                      textContent: _toDisplayString(_ctx.form.name.error_message)
                    }, null, 8, _hoisted_10))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[11] || (_cache[11] = _createElementVNode("label", { class: "text-xs mb-1" }, "Active", -1)),
                _createElementVNode("label", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.isActive) = $event)),
                    class: "hidden peer"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.form.isActive]
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass('relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (_ctx.form.isActive ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]'))
                  }, null, 2)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", {
                class: _normalizeClass('input-wrapper ' + (_ctx.form.message.error_type))
              }, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "text-xs mb-1" }, "Description", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  onKeyup: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validateFields(['message']))),
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.message.value) = $event)),
                  placeholder: "May the Fourth be with you!",
                  class: "block border-none rounded bg-gray-black w-full h-[70px] text-sm text-theme-white placeholder-gray-100::placeholder"
                }, null, 544), [
                  [_vModelText, _ctx.form.message.value]
                ]),
                (_ctx.form.message.error_message)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: "field-error label-text mt-1",
                      textContent: _toDisplayString(_ctx.form.message.error_message)
                    }, null, 8, _hoisted_16))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", {
                class: _normalizeClass('input-wrapper clearable ' + (_ctx.form.startDate.error_type))
              }, [
                _cache[14] || (_cache[14] = _createElementVNode("label", { class: "text-xs mb-1" }, "Start Date", -1)),
                _createElementVNode("div", _hoisted_19, [
                  _cache[13] || (_cache[13] = _createElementVNode("span", { class: "ml-2 mr-2" }, [
                    _createElementVNode("svg", {
                      width: "18",
                      height: "20",
                      viewBox: "0 0 18 20",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        d: "M9 12C8.71667 12 8.47917 11.9042 8.2875 11.7125C8.09583 11.5208 8 11.2833 8 11C8 10.7167 8.09583 10.4792 8.2875 10.2875C8.47917 10.0958 8.71667 10 9 10C9.28333 10 9.52083 10.0958 9.7125 10.2875C9.90417 10.4792 10 10.7167 10 11C10 11.2833 9.90417 11.5208 9.7125 11.7125C9.52083 11.9042 9.28333 12 9 12ZM5 12C4.71667 12 4.47917 11.9042 4.2875 11.7125C4.09583 11.5208 4 11.2833 4 11C4 10.7167 4.09583 10.4792 4.2875 10.2875C4.47917 10.0958 4.71667 10 5 10C5.28333 10 5.52083 10.0958 5.7125 10.2875C5.90417 10.4792 6 10.7167 6 11C6 11.2833 5.90417 11.5208 5.7125 11.7125C5.52083 11.9042 5.28333 12 5 12ZM13 12C12.7167 12 12.4792 11.9042 12.2875 11.7125C12.0958 11.5208 12 11.2833 12 11C12 10.7167 12.0958 10.4792 12.2875 10.2875C12.4792 10.0958 12.7167 10 13 10C13.2833 10 13.5208 10.0958 13.7125 10.2875C13.9042 10.4792 14 10.7167 14 11C14 11.2833 13.9042 11.5208 13.7125 11.7125C13.5208 11.9042 13.2833 12 13 12ZM9 16C8.71667 16 8.47917 15.9042 8.2875 15.7125C8.09583 15.5208 8 15.2833 8 15C8 14.7167 8.09583 14.4792 8.2875 14.2875C8.47917 14.0958 8.71667 14 9 14C9.28333 14 9.52083 14.0958 9.7125 14.2875C9.90417 14.4792 10 14.7167 10 15C10 15.2833 9.90417 15.5208 9.7125 15.7125C9.52083 15.9042 9.28333 16 9 16ZM5 16C4.71667 16 4.47917 15.9042 4.2875 15.7125C4.09583 15.5208 4 15.2833 4 15C4 14.7167 4.09583 14.4792 4.2875 14.2875C4.47917 14.0958 4.71667 14 5 14C5.28333 14 5.52083 14.0958 5.7125 14.2875C5.90417 14.4792 6 14.7167 6 15C6 15.2833 5.90417 15.5208 5.7125 15.7125C5.52083 15.9042 5.28333 16 5 16ZM13 16C12.7167 16 12.4792 15.9042 12.2875 15.7125C12.0958 15.5208 12 15.2833 12 15C12 14.7167 12.0958 14.4792 12.2875 14.2875C12.4792 14.0958 12.7167 14 13 14C13.2833 14 13.5208 14.0958 13.7125 14.2875C13.9042 14.4792 14 14.7167 14 15C14 15.2833 13.9042 15.5208 13.7125 15.7125C13.5208 15.9042 13.2833 16 13 16ZM1.5 20C1.1 20 0.75 19.85 0.45 19.55C0.15 19.25 0 18.9 0 18.5V3C0 2.6 0.15 2.25 0.45 1.95C0.75 1.65 1.1 1.5 1.5 1.5H3.125V0H4.75V1.5H13.25V0H14.875V1.5H16.5C16.9 1.5 17.25 1.65 17.55 1.95C17.85 2.25 18 2.6 18 3V18.5C18 18.9 17.85 19.25 17.55 19.55C17.25 19.85 16.9 20 16.5 20H1.5ZM1.5 18.5H16.5V7.75H1.5V18.5ZM1.5 6.25H16.5V3H1.5V6.25ZM1.5 6.25V3V6.25Z",
                        fill: "white"
                      })
                    ])
                  ], -1)),
                  _createVNode(_component_Datepicker, {
                    clearable: true,
                    inputFormat: "yyyy-MM-dd",
                    lowerLimit: new Date(),
                    placeholder: "Select a Date",
                    modelValue: _ctx.form.startDate.value,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.startDate.value) = $event)),
                    class: "focus:border-transparent focus:ring-0 bg-gray-black border-0 w-full"
                  }, null, 8, ["lowerLimit", "modelValue"])
                ]),
                (_ctx.form.startDate.error_message)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: "field-error label-text mt-1",
                      textContent: _toDisplayString(_ctx.form.startDate.error_message)
                    }, null, 8, _hoisted_20))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", {
                class: _normalizeClass('input-wrapper clearable ' + (_ctx.form.endDate.error_type))
              }, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { class: "text-xs mb-1" }, "End Date", -1)),
                _createElementVNode("div", _hoisted_22, [
                  _cache[15] || (_cache[15] = _createElementVNode("span", { class: "ml-2 mr-2" }, [
                    _createElementVNode("svg", {
                      width: "18",
                      height: "20",
                      viewBox: "0 0 18 20",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        d: "M9 12C8.71667 12 8.47917 11.9042 8.2875 11.7125C8.09583 11.5208 8 11.2833 8 11C8 10.7167 8.09583 10.4792 8.2875 10.2875C8.47917 10.0958 8.71667 10 9 10C9.28333 10 9.52083 10.0958 9.7125 10.2875C9.90417 10.4792 10 10.7167 10 11C10 11.2833 9.90417 11.5208 9.7125 11.7125C9.52083 11.9042 9.28333 12 9 12ZM5 12C4.71667 12 4.47917 11.9042 4.2875 11.7125C4.09583 11.5208 4 11.2833 4 11C4 10.7167 4.09583 10.4792 4.2875 10.2875C4.47917 10.0958 4.71667 10 5 10C5.28333 10 5.52083 10.0958 5.7125 10.2875C5.90417 10.4792 6 10.7167 6 11C6 11.2833 5.90417 11.5208 5.7125 11.7125C5.52083 11.9042 5.28333 12 5 12ZM13 12C12.7167 12 12.4792 11.9042 12.2875 11.7125C12.0958 11.5208 12 11.2833 12 11C12 10.7167 12.0958 10.4792 12.2875 10.2875C12.4792 10.0958 12.7167 10 13 10C13.2833 10 13.5208 10.0958 13.7125 10.2875C13.9042 10.4792 14 10.7167 14 11C14 11.2833 13.9042 11.5208 13.7125 11.7125C13.5208 11.9042 13.2833 12 13 12ZM9 16C8.71667 16 8.47917 15.9042 8.2875 15.7125C8.09583 15.5208 8 15.2833 8 15C8 14.7167 8.09583 14.4792 8.2875 14.2875C8.47917 14.0958 8.71667 14 9 14C9.28333 14 9.52083 14.0958 9.7125 14.2875C9.90417 14.4792 10 14.7167 10 15C10 15.2833 9.90417 15.5208 9.7125 15.7125C9.52083 15.9042 9.28333 16 9 16ZM5 16C4.71667 16 4.47917 15.9042 4.2875 15.7125C4.09583 15.5208 4 15.2833 4 15C4 14.7167 4.09583 14.4792 4.2875 14.2875C4.47917 14.0958 4.71667 14 5 14C5.28333 14 5.52083 14.0958 5.7125 14.2875C5.90417 14.4792 6 14.7167 6 15C6 15.2833 5.90417 15.5208 5.7125 15.7125C5.52083 15.9042 5.28333 16 5 16ZM13 16C12.7167 16 12.4792 15.9042 12.2875 15.7125C12.0958 15.5208 12 15.2833 12 15C12 14.7167 12.0958 14.4792 12.2875 14.2875C12.4792 14.0958 12.7167 14 13 14C13.2833 14 13.5208 14.0958 13.7125 14.2875C13.9042 14.4792 14 14.7167 14 15C14 15.2833 13.9042 15.5208 13.7125 15.7125C13.5208 15.9042 13.2833 16 13 16ZM1.5 20C1.1 20 0.75 19.85 0.45 19.55C0.15 19.25 0 18.9 0 18.5V3C0 2.6 0.15 2.25 0.45 1.95C0.75 1.65 1.1 1.5 1.5 1.5H3.125V0H4.75V1.5H13.25V0H14.875V1.5H16.5C16.9 1.5 17.25 1.65 17.55 1.95C17.85 2.25 18 2.6 18 3V18.5C18 18.9 17.85 19.25 17.55 19.55C17.25 19.85 16.9 20 16.5 20H1.5ZM1.5 18.5H16.5V7.75H1.5V18.5ZM1.5 6.25H16.5V3H1.5V6.25ZM1.5 6.25V3V6.25Z",
                        fill: "white"
                      })
                    ])
                  ], -1)),
                  _createVNode(_component_Datepicker, {
                    clearable: true,
                    inputFormat: "yyyy-MM-dd",
                    lowerLimit: new Date(),
                    placeholder: "Select a Date",
                    modelValue: _ctx.form.endDate.value,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.endDate.value) = $event)),
                    class: "focus:border-transparent focus:ring-0 bg-gray-black border-0 w-full"
                  }, null, 8, ["lowerLimit", "modelValue"])
                ]),
                (_ctx.form.endDate.error_message)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: "field-error label-text mt-1",
                      textContent: _toDisplayString(_ctx.form.endDate.error_message)
                    }, null, 8, _hoisted_23))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ]),
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "bg-theme-borderblack h-1 w-full my-4" }, null, -1)),
          (_ctx.form.startDate.value && _ctx.form.endDate.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.holidayDates.length < 1)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_24, "End time must be greater than start date."))
                  : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.holidayDates, (day, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: day.holidayDate + 'loop'
                        }, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("label", {
                                  class: "flex items-center cursor-pointer mt-5",
                                  onClick: _withModifiers(($event: any) => (day.isOpen = !day.isOpen), ["prevent"])
                                }, [
                                  _createElementVNode("div", _hoisted_30, _toDisplayString(day.holidayDateDisplay), 1),
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    class: "hidden peer",
                                    "onUpdate:modelValue": ($event: any) => ((day.isOpen) = $event)
                                  }, null, 8, _hoisted_31), [
                                    [_vModelCheckbox, day.isOpen]
                                  ]),
                                  _createElementVNode("div", {
                                    class: _normalizeClass('relative toggle-bg  border-2  h-6 w-11 rounded-full mx-2 ' + (day.isOpen ? 'bg-theme-green border-theme-green' : 'bg-theme-red border-theme-red'))
                                  }, null, 2),
                                  _createElementVNode("span", {
                                    class: _normalizeClass('ml-2 text-white text-sm font-medium uppercase ' + (day.isOpen ? 'text-theme-green' : 'text-theme-red'))
                                  }, _toDisplayString(day.isOpen ? 'OPEN' : 'CLOSED'), 3)
                                ], 8, _hoisted_29)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                _cache[18] || (_cache[18] = _createElementVNode("label", { class: "text-xs font-normal mb-1" }, "Start Time", -1)),
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("div", _hoisted_35, [
                                    _withDirectives(_createElementVNode("select", {
                                      onChange: _withModifiers(($event: any) => (_ctx.validateStartEndTime(index)), ["prevent"]),
                                      "onUpdate:modelValue": ($event: any) => ((day.openTime.HH) = $event),
                                      class: "bg-gray-black border-0 focus:border-transparent focus:ring-0 text-sm w-[100px] pl-2 py-0 pr-0 sm-arrow"
                                    }, [
                                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (hour) => {
                                        return _createElementVNode("option", {
                                          value: hour > 9 ? hour : '0'+hour,
                                          key: hour + 'hour'
                                        }, _toDisplayString(hour > 9 ? hour : '0'+hour), 9, _hoisted_37)
                                      }), 64))
                                    ], 40, _hoisted_36), [
                                      [_vModelSelect, day.openTime.HH]
                                    ]),
                                    _cache[17] || (_cache[17] = _createElementVNode("span", null, ":", -1)),
                                    _withDirectives(_createElementVNode("select", {
                                      "onUpdate:modelValue": ($event: any) => ((day.openTime.MM) = $event),
                                      onChange: _withModifiers(($event: any) => (_ctx.validateStartEndTime(index)), ["prevent"]),
                                      class: "bg-gray-black border-0 focus:border-transparent focus:ring-0 text-sm w-[100px] pl-2 py-0 pr-0 sm-arrow"
                                    }, [
                                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(60, (key, min) => {
                                        return _createElementVNode("option", {
                                          value: min > 9 ? min : '0'+min,
                                          key: min + 'min'
                                        }, _toDisplayString(min > 9 ? min : '0'+min), 9, _hoisted_39)
                                      }), 64))
                                    ], 40, _hoisted_38), [
                                      [_vModelSelect, day.openTime.MM]
                                    ])
                                  ]),
                                  _createElementVNode("label", _hoisted_40, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      onChange: _withModifiers(($event: any) => (_ctx.validateStartEndTime(index)), ["prevent"]),
                                      "onUpdate:modelValue": ($event: any) => ((day.openTimeTypeAm) = $event),
                                      class: "hidden peer"
                                    }, null, 40, _hoisted_41), [
                                      [_vModelCheckbox, day.openTimeTypeAm]
                                    ]),
                                    _createElementVNode("div", {
                                      class: _normalizeClass('relative toggle-bg ampm-inside-switch border-2  h-6 w-[50px] rounded-full ' + (day.openTimeTypeAm ? 'bg-theme-darkgreen border-theme-green' : 'bg-theme-darkgreen  border-theme-green'))
                                    }, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass('text-white  text-xs leading-loose right-1 ' + (day.openTimeTypeAm ? 'left' : 'right'))
                                      }, _toDisplayString(day.openTimeTypeAm ? 'AM' : 'PM'), 3)
                                    ], 2)
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("div", _hoisted_43, [
                                _cache[20] || (_cache[20] = _createElementVNode("label", { class: "text-xs font-normal mb-1" }, "End Time", -1)),
                                _createElementVNode("div", _hoisted_44, [
                                  _createElementVNode("div", _hoisted_45, [
                                    _withDirectives(_createElementVNode("select", {
                                      "onUpdate:modelValue": ($event: any) => ((day.closeTime.HH) = $event),
                                      onChange: _withModifiers(($event: any) => (_ctx.validateStartEndTime(index)), ["prevent"]),
                                      class: "bg-gray-black border-0 focus:border-transparent focus:ring-0 text-sm w-[100px] pl-2 py-0 pr-0 sm-arrow"
                                    }, [
                                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (hour) => {
                                        return _createElementVNode("option", {
                                          value: hour > 9 ? hour : '0'+hour,
                                          key: hour + 'hour'
                                        }, _toDisplayString(hour > 9 ? hour : '0'+hour), 9, _hoisted_47)
                                      }), 64))
                                    ], 40, _hoisted_46), [
                                      [_vModelSelect, day.closeTime.HH]
                                    ]),
                                    _cache[19] || (_cache[19] = _createElementVNode("span", null, ":", -1)),
                                    _withDirectives(_createElementVNode("select", {
                                      "onUpdate:modelValue": ($event: any) => ((day.closeTime.MM) = $event),
                                      onChange: _withModifiers(($event: any) => (_ctx.validateStartEndTime(index)), ["prevent"]),
                                      class: "bg-gray-black focus:border-transparent focus:ring-0 border-0 text-sm w-[100px] py-0 pl-2 pr-0 sm-arrow"
                                    }, [
                                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(60, (key, min) => {
                                        return _createElementVNode("option", {
                                          value: min > 9 ? min : '0'+min,
                                          key: min + 'min'
                                        }, _toDisplayString(min > 9 ? min : '0'+min), 9, _hoisted_49)
                                      }), 64))
                                    ], 40, _hoisted_48), [
                                      [_vModelSelect, day.closeTime.MM]
                                    ])
                                  ]),
                                  _createElementVNode("label", _hoisted_50, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      onChange: _withModifiers(($event: any) => (_ctx.validateStartEndTime(index)), ["prevent"]),
                                      "onUpdate:modelValue": ($event: any) => ((day.closeTimeTypeAm) = $event),
                                      class: "hidden peer"
                                    }, null, 40, _hoisted_51), [
                                      [_vModelCheckbox, day.closeTimeTypeAm]
                                    ]),
                                    _createElementVNode("div", {
                                      class: _normalizeClass('relative toggle-bg ampm-inside-switch border-2  h-6 w-[50px] rounded-full ' + (day.closeTimeTypeAm ? 'bg-theme-darkgreen border-theme-green' : 'bg-theme-darkgreen  border-theme-green'))
                                    }, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass('text-white  text-xs leading-loose ' + (day.closeTimeTypeAm ? 'left' : 'right'))
                                      }, _toDisplayString(day.closeTimeTypeAm ? 'AM' : 'PM'), 3)
                                    ], 2)
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          (day.is_valid_openTime_closeTime == false)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_52, "End time must be greater than start time."))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
              ], 64))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.deleteObj.modal)
      ? (_openBlock(), _createBlock(_component_ReturnConfirmModal, {
          key: 0,
          obj: _ctx.deleteObj.obj,
          closeClick: _ctx.closeDeleteModal,
          actionClick: _ctx.deleteNow,
          heading: 'You Are About To Delete ' + _ctx.deleteObj.obj.name 
        }, null, 8, ["obj", "closeClick", "actionClick", "heading"]))
      : _createCommentVNode("", true)
  ], 64))
}